// 試卷派送整頁（exam-dispatch-exam＝legacy dispatchExam.jsp：查詢表單＋listTable＋分派 modal）。
// 批次 13（B3-3，Gitea issue #8）。掛在 PageBehavior.complexBody（ComplexFormPage 的 opt-in
// 整頁置換，批次 10 editModal 同款「未登錄頁零影響」；該頁 pageType=complex-form 為產生檔紅線，
// 不能改頁型，故以 complexBody 取代「單筆表單」模板）。
//
// legacy 流程（行號逐檔 grep -n 親驗 2026-09-23；詳 docs/plans/2026-09-23-batch13-exam-modal-progress.md §1.2）：
//   - 查詢表單（dispatchExam.jsp:28-62）：annualId/organizationId/jobTypeId/departmentId/planTargetId/
//     phaseTargetId（training/commonQueryFields.jsp include）＋測試目標 examTargetId（label :33/
//     select :34-36，label 帶紅星但 select 無 required）＋分派狀態 dispatchStatus（label :40/
//     select :41-52——『全部』-1 是 JSP 靜態 :43-45；未分派0/已分派1 選項來自 server
//     dispatchStatusList＝DispatchStatus.java NOT(0,未分派)/DONE(1,已分派)，雛形硬編同值
//     【雛形值待實機校準】）＋查詢/分派鈕（:53-56）。
//   - listTable（:65，欄定義 :183-236：checkbox :185/測驗目標 :193/學生姓名 :201/發送日 :210/
//     應完成日 :219/成績記錄 :228；select-all 表頭 :181）：
//     學生姓名 studentName/發送日 createDateStr/應完成日 finishDateStr/成績記錄 genScroe。
//   - genCheckBox（:264-281）：testingListStatus==INIT(0 未作答)或 ANSWERED(2 待審核)→
//     disabled＋class="hidden"（**整顆藏掉**，不可再分派）。
//   - genScroe（:298-325）：testingList 空→紅『未分派』(:302)；逐筆 INIT→藍『未作答』(:313)、
//     ANSWERED→綠『待審核』(:315)、DELAY→綠『逾期未作答』(:317)、VERIFIED→test_score(:319)；
//     ANSWERING(1) 無分支→空字串；`<br>` 串接。
//     （TestingStatus.java:4-8：INIT(0,未作答)/ANSWERING(1,作答中)/ANSWERED(2,待審核)/
//     VERIFIED(3,已完成)/DELAY(4,逾期未作答)。）
//   - select-all（:244-254）：search applied 範圍全勾/全消。
//   - showModal（:369-377）：勾選資料 0 筆→showAlertDialog『請先勾選要分派的學生!』(:372)；
//     開啟時 finishDate 清空（:375）。
//   - dispatchExam（:382-437）驗證鏈（順序固定）：finishDate 空→『請設定應完成日!』(:390)→
//     finishDate<今日（legacy 比較 new Date(finishDate) < 現在-1天，語意＝**不可小於今日**）→
//     『應完成日不可小於今日!』(:394)→teacherId 空→『請設定閱卷負責人!』(:398)→examTargetId 空
//     （**讀查詢表單** :401）→『請設定測試目標!』(:402)→勾選 0 筆→『沒有勾選資料!』(:408)→
//     POST dispatchExamInstAjax→成功：info＋closeModal＋doQuery。
//   - 分派前的 sysConfirm 整段被註解（:411-421 check rule block＋:423 sysConfirm 註解）＝**legacy-known-issue**：
//     直接送出不二次確認，照實鏡像（不加 confirm）。
//   - 分派 modal（:76-134，dispatchForm :87）：應完成日 finishDate（datepicker readonly required
//     maxlength10，input :93-97）＋閱卷負責人 teacherCode（text，placeholder『(請輸入姓名或編號)』
//     :104-105）＋teacherId（select :109-111，setAnyAccountList 配對 :174；預設帶入
//     `${account.name}` :175）；鈕：關閉/分派（:114-122）。
//
// 雛形資料策略：
//   - 清單＝`useList('exam-dispatch-exam')`＋EXAM_DISPATCH_SEED（未分派×2＋已分派四態種子）；
//     分派寫入＝對勾選列 dataSource.update（testingList 補 INIT『未作答』紀錄＋finishDateStr/
//     teacherId/testingListStatus），D-1 5-op 之內、真呼叫才帶 data-effect（C5-j）。
//   - 分派狀態/測試目標過濾＝用戶端（legacy 是伺服器端 getExamTargetDispatchListAjax）
//     【雛形值待實機校準】；其餘 6 個查詢欄雛形只渲染不過濾（同上）。
//   - 「今日」＝fixtures DATE_EPOCH 2026/01/05（不用 Date.now()；CourseViewModal 首頁模式先例）
//     【雛形值待實機校準】。
//   - 應完成日 datepicker→文字輸入【雛形值待實機校準】；teacherCode 預設＝種子帳號名『教師甲』
//     （legacy `${account.name}`）【雛形值待實機校準】；閱卷負責人選項＝EXAM_DISPATCH_TEACHER_OPTIONS
//     （legacy setAnyAccountList 帶真帳號清單）【雛形值待實機校準】。
//   - LegacyContractModals 照舊渲染（D-3 trigger 保留，批次 11「spec modal 與自訂 modal 並存」先例）。
//
// 【證據等級】§7 第 3 級（原始碼）。

import { useEffect, useRef, useState, type ReactElement } from 'react';
import { panelHeadingLevelFor } from '@/app/panel-heading-levels';
import { Button } from '@/components/base/Button';
import { FormWrap, toUiKey } from '@/pages/templates/shared';
import { Checkbox } from '@/components/base/Checkbox';
import { Select } from '@/components/base/Select';
import { Table, type TableColumn } from '@/components/base/Table';
import { TextInput } from '@/components/base/TextInput';
import { ContentPanel, ModalFrame, useDialogs } from '@/components/layouts';
import { LegacyContractModals } from '@/components/layouts/LegacyContractModals';
import { t } from '@/messages/zh-TW';
import { useDataSource } from '@/mocks';
import { selectOptionsOverride } from '@/mocks/legacy-fields';
import {
  ACCOUNT_DEPARTMENT_OPTIONS,
  ACCOUNT_JOB_TYPE_OPTIONS,
  ACCOUNT_ORGANIZATION_OPTIONS,
  COURSE_CLAZZ_ANNUAL_OPTIONS,
  COURSE_CLAZZ_PLAN_TARGET_OPTIONS,
  COURSE_CLAZZ_PHASE_OPTIONS,
  EXAM_DISPATCH_TEACHER_OPTIONS,
  EXAM_TARGET_OPTIONS,
} from '@/mocks/resource-rules';
import type { Row } from '@/mocks/types';
/** 固定「今天」（fixtures DATE_EPOCH_MS＝2026/01/05；不用 Date.now()）【雛形值待實機校準】。 */
const EXAM_DISPATCH_TODAY = '2026/01/05';

/** 'YYYY/MM/DD' → Date（比對用；legacy new Date(finishDate) 同樣交給瀏覽器解析）。 */
function dateOf(value: string): Date {
  return new Date(value);
}

/** genCheckBox（:264-281）：INIT(0)／ANSWERED(2) 的勾選欄整顆藏掉。 */
function checkHiddenOf(row: Row): boolean {
  const status = String(row['testingListStatus'] ?? '');
  return status === '0' || status === '2';
}

/** genScroe（:298-325）的純文字鏡像（顏色以靜態 class 呈現，文字逐字）。 */
function scoreRecordOf(row: Row): ReactElement {
  const list = row['testingList'];
  if (!Array.isArray(list) || list.length === 0) {
    return <span className="bg-red-600 px-1 text-white">未分派</span>; // :302 makeTextRed
  }
  const parts: ReactElement[] = [];
  for (const entry of list as ReadonlyArray<Record<string, unknown>>) {
    const status = String(entry['test_status'] ?? '');
    const score = String(entry['test_score'] ?? '');
    let node: ReactElement;
    if (status === '0') {
      node = <span className="bg-blue-600 px-1 text-white">未作答</span>; // makeTextBule（:313）
    } else if (status === '2') {
      node = <span className="bg-green-600 px-1 text-white">待審核</span>; // makeTextGreen（:315）
    } else if (status === '4') {
      node = <span className="bg-green-600 px-1 text-white">逾期未作答</span>; // makeTextGreen（:317）
    } else if (status === '3') {
      node = <span>{score}</span>; // VERIFIED → test_score（:319）
    } else {
      // ANSWERING(1)：legacy genScroe 無此分支 → t=''（空字串，:308-319），照實不畫字。
      node = <span />;
    }
    parts.push(node);
  }
  return (
    <>
      {parts.map((part, index) => (
        <span key={index}>
          {index > 0 ? <br /> : null}
          {part}
        </span>
      ))}
    </>
  );
}

export function DispatchExamBody({ pageId }: { pageId: string }): ReactElement {
  const dataSource = useDataSource();
  const dialogs = useDialogs();
  // 批次 52 修訂（b52-calibrate3，F-2）：OPTION_SET_OVERRIDES 命中＝凍結選項集取代寫死常數
  // （規格 .tmp/tasks/orca-tasks/b52-seed-spec.md §7.1；照已接線 7 檔同構一行式）。placeholder 同法：
  // override 命中（含空陣列＝凍結真真空 0 options）即移除 placeholder 空選項。
  const overrideOptions = (name: string) => selectOptionsOverride(pageId, name);

  // ------------------------------------------------------------------
  // 查詢表單（dispatchExam.jsp:28-62；dispatchStatus 預設全部 -1）。欄位 name 照
  // legacy 表單（C5-h 接線率掃描用；值經查詢的 list filters 進 DataSource）。
  // ------------------------------------------------------------------
  const [annualId, setAnnualId] = useState('');
  const [organizationId, setOrganizationId] = useState('');
  const [jobTypeId, setJobTypeId] = useState('');
  const [departmentId, setDepartmentId] = useState('');
  const [planTargetId, setPlanTargetId] = useState('');
  const [phaseTargetId, setPhaseTargetId] = useState('');
  const [examTargetId, setExamTargetId] = useState('');
  const [dispatchStatus, setDispatchStatus] = useState('-1');

  // ------------------------------------------------------------------
  // 清單（doQuery :327-350 鏡像：list 帶 filters；matchesFilters 對 '' 不過濾）。
  // 自管資料（不用 useList）：查詢要帶 filters 重取，分派後 reload 沿用同組 filters。
  // ------------------------------------------------------------------
  const [rows, setRows] = useState<readonly Row[]>([]);
  const [busy, setBusy] = useState(false);
  const appliedRef = useRef<Record<string, string>>({});
  const load = (filters: Record<string, string>) => {
    void (async () => {
      setBusy(true);
      try {
        const result = await dataSource.list(pageId, { page: 1, pageSize: 50, filters });
        setRows(result.rows);
      } catch (cause: unknown) {
        await dialogs.alert(cause instanceof Error ? cause.message : t('error.generic'));
      } finally {
        setBusy(false);
      }
    })();
  };
  // biome-ignore lint/correctness/useExhaustiveDependencies: 首載一次（pageId 掛載內不變）。
  useEffect(() => {
    load(appliedRef.current);
  }, []);

  // ------------------------------------------------------------------
  // 勾選（genCheckBox/getDataList）與分派 modal（showModal/dispatchExam）。
  // ------------------------------------------------------------------
  const [selected, setSelected] = useState<ReadonlySet<string>>(new Set());
  const [dispatchOpen, setDispatchOpen] = useState(false);
  const [finishDate, setFinishDate] = useState('');
  const [teacherCode, setTeacherCode] = useState('教師甲'); // :175 `${account.name}`【雛形值待實機校準】
  const [teacherId, setTeacherId] = useState('t-1');

  /** doQuery（:327-350）：表單值入 list filters（''/-1 不過濾，matchesFilters 語意）。 */
  const doQuery = () => {
    const filters: Record<string, string> = {
      annualId,
      organizationId,
      jobTypeId,
      departmentId,
      planTargetId,
      phaseTargetId,
      examTargetId,
      dispatchStatus: dispatchStatus === '-1' ? '' : dispatchStatus,
    };
    appliedRef.current = filters;
    load(filters);
  };

  const saveSuccessText = () => t('state.saveSuccess');

  const eligibleRows = rows.filter((row) => !checkHiddenOf(row));
  const allChecked =
    eligibleRows.length > 0 && eligibleRows.every((row) => selected.has(String(row.id ?? '')));

  /** 分派鈕（showModal :369-377）：先驗勾選，再開 modal（finishDate 清空 :375）。 */
  const openDispatch = () => {
    if (selected.size === 0) {
      void dialogs.alert('請先勾選要分派的學生!'); // :372
      return;
    }
    setFinishDate(''); // :375
    setDispatchOpen(true);
  };

  /** teacherCode/teacherId 配對（setAnyAccountList :174-176 鏡像簡化：輸入符合選項文字才帶值）。 */
  const teacherOptions = EXAM_DISPATCH_TEACHER_OPTIONS;
  const teacherByLabel = (label: string) =>
    teacherOptions.find((option) => option.label === label) ?? null;

  /** 分派送出（dispatchExam :382-437）：六段驗證鏈（順序固定）＋逐列 update。 */
  const dispatchExam = () => {
    void (async () => {
      if (finishDate.trim() === '') {
        await dialogs.alert('請設定應完成日!'); // :390
        return;
      }
      // :391-397 legacy new Date(finishDate) < 現在-1天 → 語意＝不可小於今日。
      if (dateOf(finishDate) < dateOf(EXAM_DISPATCH_TODAY)) {
        await dialogs.alert('應完成日不可小於今日!'); // :394
        return;
      }
      if (teacherId === '') {
        await dialogs.alert('請設定閱卷負責人!'); // :398
        return;
      }
      // :388/:400-405 examTargetId 讀**查詢表單**（本頁狀態；legacy :388 讀 #examTargetId）。
      if (examTargetId === '') {
        await dialogs.alert('請設定測試目標!'); // :402
        return;
      }
      if (selected.size === 0) {
        await dialogs.alert('沒有勾選資料!'); // :408
        return;
      }
      // 分派寫入：勾選列補 INIT『未作答』紀錄＋應完成日／閱卷負責人（dispatchExamInstAjax 鏡像）。
      setBusy(true);
      try {
        let sequence = 0;
        for (const id of selected) {
          const row = rows.find((entry) => String(entry.id) === id);
          if (row === undefined) {
            continue;
          }
          sequence += 1;
          const existing = Array.isArray(row['testingList'])
            ? (row['testingList'] as ReadonlyArray<Record<string, unknown>>)
            : [];
          await dialogs.processing.wrap(
            dataSource.update(pageId, id, {
              testingList: [
                ...existing,
                { test_id: `t-9${String(sequence).padStart(3, '0')}`, test_status: '0', test_score: '' },
              ],
              testingListStatus: '0',
              dispatchStatus: '1', // 分派狀態查詢過濾用（雛形欄【雛形值待實機校準】）
              finishDateStr: finishDate,
              endDate: finishDate,
              teacherId,
            }),
          );
        }
        load(appliedRef.current); // doQuery（:429；沿用最後一次查詢的 filters）
        setSelected(new Set());
        setDispatchOpen(false); // closeModal（:428）
        await dialogs.info(saveSuccessText()); // :427 showInfoDialog(response.desc)
      } catch (cause: unknown) {
        await dialogs.alert(cause instanceof Error ? cause.message : t('error.generic'));
      } finally {
        setBusy(false);
      }
    })();
  };

  // ------------------------------------------------------------------
  // 畫面
  // ------------------------------------------------------------------
  const queryField = (key: string, label: string, required: boolean, control: ReactElement) => (
    <div className="flex items-center gap-2">
      {/* 批次 50（工作項 4）：htmlFor 字尾 toUiKey kebab 化，與呼叫端 kebab 字面 uiId 成對。 */}
      <label className="w-24 shrink-0 text-sm" htmlFor={`${pageId}-dispatch-query-${toUiKey(key)}`}>
        {required ? <span className="text-danger">*</span> : null}
        {label}
      </label>
      {control}
    </div>
  );

  const columns: readonly TableColumn[] = [
    // 批次 44（#42）：表頭全選（legacy thead 第一欄 input[type=checkbox]）。
    {
      key: 'check',
      header: (
        <input
          type="checkbox"
          data-ui-id="form-dispatch-exam-form-select-all"
          className="size-4 accent-brand"
          onChange={(event) => {
            // 批次 44：全選＝勾選本頁全部列（selected set；批次 13 既有 selection 語意）。
            setSelected((current) => {
              const next = new Set(current);
              if (event.target.checked) {
                for (const row of rows) next.add(String(row.id ?? ''));
              } else {
                next.clear();
              }
              return next;
            });
          }}
        />
      ),
      align: 'center',
    },
    { key: 'examTargetIdName', header: '測驗目標', align: 'center' },
    { key: 'studentName', header: '學生姓名', align: 'center' },
    { key: 'createDateStr', header: '發送日', align: 'center' },
    { key: 'finishDateStr', header: '應完成日', align: 'center' },
    { key: 'scoreRecord', header: '成績記錄', align: 'center' },
  ];

  return (
    <div data-ui-id={pageId}>
      {/*
        D-3：spec modal（#dialogModal 試卷派送 3 欄）照舊渲染（批次 11「spec modal 與自訂
        modal 並存」先例）；下方分派 modal 為本批接線的互動版（uiId dispatch-dialog）。
      */}
      <LegacyContractModals pageId={pageId} />
      <ContentPanel uiId={`${pageId}-panel`} title="試卷派送" headingLevel={panelHeadingLevelFor(pageId)}>
        {/* 查詢表單（dispatchExam.jsp:28-62）。 */}
        {/* 批次 37（GNL-005-b Phase 2）：查詢欄位＋查詢/分派鈕包 form 鏡像 legacy。 */}
        <FormWrap pageId={pageId}>
        <div data-ui-id={`${pageId}-dispatch-query`} className="mb-4 grid grid-cols-2 gap-2">
          {queryField('annualId', '學年度：', true, (
            <Select
              uiId={`${pageId}-dispatch-query-annual-id`}
                name="annualId"
              value={annualId}
              onChange={setAnnualId}
              options={overrideOptions('annualId') ?? COURSE_CLAZZ_ANNUAL_OPTIONS}
              {...(overrideOptions('annualId') ? {} : { placeholder: '請選擇' })}
            />
          ))}
          {queryField('organizationId', '醫院：', true, (
            <Select
              uiId={`${pageId}-dispatch-query-organization-id`}
                name="organizationId"
              value={organizationId}
              onChange={setOrganizationId}
              options={overrideOptions('organizationId') ?? ACCOUNT_ORGANIZATION_OPTIONS}
              {...(overrideOptions('organizationId') ? {} : { placeholder: '請選擇' })}
            />
          ))}
          {queryField('jobTypeId', '訓練類別：', true, (
            <Select
              uiId={`${pageId}-dispatch-query-job-type-id`}
                name="jobTypeId"
              value={jobTypeId}
              onChange={setJobTypeId}
              options={overrideOptions('jobTypeId') ?? ACCOUNT_JOB_TYPE_OPTIONS}
              {...(overrideOptions('jobTypeId') ? {} : { placeholder: '請選擇' })}
            />
          ))}
          {queryField('departmentId', '科部：', true, (
            <Select
              uiId={`${pageId}-dispatch-query-department-id`}
                name="departmentId"
              value={departmentId}
              onChange={setDepartmentId}
              options={overrideOptions('departmentId') ?? ACCOUNT_DEPARTMENT_OPTIONS}
              {...(overrideOptions('departmentId') ? {} : { placeholder: '請選擇' })}
            />
          ))}
          {queryField('planTargetId', '訓練計畫：', true, (
            <Select
              uiId={`${pageId}-dispatch-query-plan-target-id`}
                name="planTargetId"
              value={planTargetId}
              onChange={setPlanTargetId}
              options={overrideOptions('planTargetId') ?? COURSE_CLAZZ_PLAN_TARGET_OPTIONS}
              {...(overrideOptions('planTargetId') ? {} : { placeholder: '請選擇' })}
            />
          ))}
          {queryField('phaseTargetId', '組別：', false, (
            <Select
              uiId={`${pageId}-dispatch-query-phase-target-id`}
                name="phaseTargetId"
              value={phaseTargetId}
              onChange={setPhaseTargetId}
              options={overrideOptions('phaseTargetId') ?? COURSE_CLAZZ_PHASE_OPTIONS}
              {...(overrideOptions('phaseTargetId') ? {} : { placeholder: '請選擇' })}
            />
          ))}
          {/* 測試目標（label :33 帶紅星；select 無 required——驗證走分派鏉 :400-405，不走表單 required）。 */}
          {queryField('examTargetId', '測試目標：', true, (
            <Select
              uiId={`${pageId}-dispatch-query-exam-target-id`}
                name="examTargetId"
              value={examTargetId}
              onChange={setExamTargetId}
              options={overrideOptions('examTargetId') ?? EXAM_TARGET_OPTIONS}
              {...(overrideOptions('examTargetId') ? {} : { placeholder: '請選擇' })}
            />
          ))}
          {queryField('dispatchStatus', '分派狀態：', true, (
            <Select
              uiId={`${pageId}-dispatch-query-dispatch-status`}
                name="dispatchStatus"
              value={dispatchStatus}
              onChange={setDispatchStatus}
              options={[
                { value: '-1', label: '全部' },
                { value: '0', label: '未分派' },
                { value: '1', label: '已分派' },
              ]}
            />
          ))}
          <div className="col-span-2 flex gap-2">
            <Button
              uiId={`${pageId}-dispatch-query-btn`}
              variant="primary"
              size="sm"
              type="button"
              // doQuery（:327-350）：表單值入 list filters 重取。
              onClick={doQuery}
            >
              查詢
            </Button>
            <Button
              uiId={`${pageId}-dispatch-btn`}
              variant="default"
              size="sm"
              type="button"
              // D-3：自報「我會開哪一個對話框」——分派 modal（本頁自訂互動版）。
              dataModalTrigger={`${pageId}-dispatch-dialog`}
              onClick={openDispatch}
            >
              分派
            </Button>
          </div>
        </div>
        </FormWrap>
        {/* listTable（:65；六欄照欄定義 :183-232）。 */}
        <Table
          uiId={`${pageId}-dispatch-table`}
          columns={columns}
          rows={rows.map((row) => ({ ...row, scoreRecord: '' }))}
          rowKey={(row) => String(row['id'] ?? '').toLowerCase()} // kebab-case（§10.1；EXA-114-0001 → exa-114-0001）
          emptyText={t('table.empty')}
          renderCell={(row, columnKey) => {
            // selection 用真列鍵（store 大寫 EXA-114-0001）；uiId 用小寫 kebab-case（§10.1）。
            const realId = String(row['id'] ?? '');
            const id = realId.toLowerCase();
            if (columnKey === 'check') {
              // genCheckBox（:264-281）：INIT/ANSWERED 整顆藏（連 disabled 都不出場）。
              if (checkHiddenOf(row)) {
                return null;
              }
              return (
                <Checkbox
                  uiId={`${pageId}-dispatch-table-row-${id}-check`}
                  checked={selected.has(realId)}
                  onChange={(checked) => {
                    const next = new Set(selected);
                    if (checked) {
                      next.add(realId);
                    } else {
                      next.delete(realId);
                    }
                    setSelected(next);
                  }}
                />
              );
            }
            if (columnKey === 'scoreRecord') {
              return scoreRecordOf(row);
            }
            return String(row[columnKey] ?? '');
          }}
        />
        {/* select-all（:244-254；雛形以表格外圈全選呈現，語意＝search applied 範圍全勾）。 */}
        <Checkbox
          uiId={`${pageId}-dispatch-table-select-all`}
          checked={allChecked}
          label="全選"
          onChange={(checked) => {
            setSelected(
              checked
                ? new Set(eligibleRows.map((row) => String(row.id ?? '')))
                : new Set<string>(),
            );
          }}
        />
      </ContentPanel>

      {/* ── 分派 modal（#dialogModal dispatchForm :87-134） ── */}
      {dispatchOpen ? (
        <ModalFrame
          uiId={`${pageId}-dispatch-dialog`}
          open
          title="試卷派送"
          size="md"
          onClose={() => {
            setDispatchOpen(false);
          }}
          footer={
            <>
              <Button
                uiId={`${pageId}-dispatch-dialog-cancel`}
                variant="default"
                size="sm"
                type="button"
                onClick={() => {
                  setDispatchOpen(false);
                }}
              >
                關閉
              </Button>
              <Button
                uiId={`${pageId}-dispatch-dialog-submit`}
                variant="primary"
                size="sm"
                type="button"
                disabled={busy}
                // C5-j：分派真的呼叫 dataSource.update（勾選列）。
                dataEffect={`update:${pageId}`}
                onClick={() => {
                  dispatchExam();
                }}
              >
                分派
              </Button>
            </>
          }
        >
          <div data-ui-id={`${pageId}-dispatch-dialog-body`} className="space-y-3">
            {/* 應完成日（:93-98；label 無星號；datepicker→文字輸入【雛形值待實機校準】）。 */}
            <div className="flex items-center gap-2">
              <label className="shrink-0 text-sm" htmlFor={`${pageId}-dispatch-field-finish-date`}>
                應完成日：
              </label>
              <TextInput
                uiId={`${pageId}-dispatch-field-finish-date`}
                value={finishDate}
                onChange={setFinishDate}
                maxLength={10}
                disabled={busy}
              />
            </div>
            {/* 閱卷負責人（:100-111：teacherCode text＋teacherId select 配對）。 */}
            <div className="flex items-center gap-2">
              <label className="shrink-0 text-sm" htmlFor={`${pageId}-dispatch-field-teacher-code`}>
                閱卷負責人：
              </label>
              <div className="flex flex-1 gap-2">
                <TextInput
                  uiId={`${pageId}-dispatch-field-teacher-code`}
                  value={teacherCode}
                  onChange={(next) => {
                    setTeacherCode(next);
                    const matched = teacherByLabel(next);
                    setTeacherId(matched === null ? '' : matched.value);
                  }}
                  placeholder="(請輸入姓名或編號)"
                  disabled={busy}
                />
                <Select
                  uiId={`${pageId}-dispatch-field-teacher-id`}
                  value={teacherId}
                  onChange={(next) => {
                    setTeacherId(next);
                    const matched = teacherOptions.find((option) => option.value === next);
                    setTeacherCode(matched === undefined ? '' : matched.label);
                  }}
                  options={teacherOptions}
                  placeholder="請選擇"
                  disabled={busy}
                />
              </div>
            </div>
          </div>
        </ModalFrame>
      ) : null}
    </div>
  );
}
